import { render, staticRenderFns } from "./Encounters.vue?vue&type=template&id=6bf8c4ed&scoped=true"
import script from "./Encounters.vue?vue&type=script&lang=js"
export * from "./Encounters.vue?vue&type=script&lang=js"
import style0 from "./Encounters.vue?vue&type=style&index=0&id=6bf8c4ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf8c4ed",
  null
  
)

export default component.exports